import { useEffect } from "react";
import { useEliteStructure } from "@/contexts/EliteTemporaryContextProvider";

/**
 * Custom hook to dynamically update document.title based on page title and current hotel structure.
 */
export function useDocumentTitle(title?: string) {
  const { structure } = useEliteStructure();

  useEffect(() => {
    const structureName = structure?.name?.trim();
    if (title && title.trim() !== "") {
      document.title = structureName ? `${title} | ${structureName}` : `${title} | App H-Elite`;
    } else if (structureName) {
      document.title = `${structureName} | App H-Elite`;
    } else {
      document.title = "App H-Elite";
    }
  }, [title, structure?.name]);
}
